import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'boma-portal-switch-directory',
  templateUrl: './portal-switch-directory.component.html',
  styleUrls: ['./portal-switch-directory.component.scss'],
})
export class PortalSwitchDirectoryComponent implements OnInit {
  @Input() switchDirectoryMenuActive;
  @Input() directories;

  @Output() changeDirectory = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
